import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import routes from "./route-config";
import LoginPage from "./pages/login/LoginPage";
import React, {Suspense} from "react";
import {useAuthenticationContext} from "@utils/auth/AuthenticationContext";
import {usePiwikContext} from "@utils/tracking/PiwikContext";
import PreloaderComponent from "./components/layout/PreloaderComponent";
import useCommentSignalRConnection from "./utils/signalr/useCommentSignalRConnection";
import AppLayout from "@pages/AppLayout";
import ProtectedRoute from "@utils/auth/ProtectedRoute";

export default function AppRouter() {
    const {isInitialized} = useAuthenticationContext();
    const {utils, trackers} = usePiwikContext();

    utils.updateUserData();
    trackers.trackUserData();
    useCommentSignalRConnection();

    if (!isInitialized) return <PreloaderComponent/>;

    return (
        <BrowserRouter>
            <Suspense fallback={<PreloaderComponent/>}>
                <Routes>
                    {/* redirect root → /en */}
                    <Route path="/" element={<Navigate to="/en" replace />} />

                    {/* no-lang login */}
                    <Route path="/login" element={<LoginPage />} />

                    {/* lang-prefixed login */}
                    <Route path="/:lng/login" element={<LoginPage />} />

                    {/* callback */}
                    {/*<Route path="/auth-callback" element={<AuthCallbackComponent />} />*/}
                    <Route path="/auth-callback" element={<LoginPage />} />

                    {/* everything else under /:lng */}
                    <Route path="/:lng" element={<AppLayout/>}>
                        {routes.map(route => {
                            const subPath = route.path.replace("/:lng/", "") || "";
                            return (
                                <Route
                                    key={route.path}
                                    path={subPath}
                                    element={
                                        <ProtectedRoute
                                            element={route.element}
                                            roleMask={route.roleMask}
                                            labFilter={route.labFilter}
                                            divisionFilter={route.divisionFilter}
                                        />
                                    }
                                />
                            );
                        })}
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
}
